<template>
  <v-card color="blue-grey" class="white--text" >    

    <v-card-title primary-title>
      <div>
        <div class="headline">Cuestionarios pendientes</div>
        <span class="grey--text text--lighten-2">Seleccione el cuestionario que desea cumplimentar</span>
      </div>
    </v-card-title>

    <div class="pa-2">
      <v-list two-line>
      <template v-for="cuestionario in cuestionarios">
        <v-list-tile 
          :key="cuestionario.ID"
          :to="{ path: '/cuestionario/' + cuestionario.ID }">
          
          <v-list-tile-action>
            <v-icon large>assignment</v-icon>
          </v-list-tile-action>

          <v-list-tile-content>
            <v-list-tile-title>{{ cuestionario.Titulo }}</v-list-tile-title>            
          </v-list-tile-content>

        </v-list-tile>
      </template>
    </v-list>
    </div>
  </v-card>

  
 </template>

<style>
</style>

<script>
  import { mapState } from 'vuex'

  export default {
    name: 'BrwCuestionarios',
    data: function () {
      return {}
    },
    methods: { 
    },
    computed: {
      ...mapState({
        cuestionarios: state => state.cuestionarios.cuestionarios
      })
    }
  }
</script>